'use client'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  if (typeof window !== 'undefined') {
    console.error('[GlobalError]', error?.message, error?.stack)
    fetch('/api/error-logs/ingest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${(window as any).__NEXT_DATA__?.runtimeConfig?.callbackSecret || 'global-error'}` },
      body: JSON.stringify({ severity: 'critical', source: 'global-error', message: error?.message || 'Unknown error', metadata: { stack: error?.stack, digest: error?.digest, url: window.location.href } }),
    }).catch(() => {})
  }

  return (
    <html>
      <body style={{ background: '#080808', color: '#f5f0e8', fontFamily: 'system-ui', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', margin: 0 }}>
        <div style={{ textAlign: 'center', maxWidth: 400, padding: 32 }}>
          <h2 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h2>
          <p style={{ fontSize: 14, opacity: 0.6, marginBottom: 24 }}>An unexpected error occurred.</p>
          <p style={{ fontSize: 12, opacity: 0.4, marginBottom: 16, fontFamily: 'monospace', wordBreak: 'break-all' }}>{error?.message}</p>
          <button
            onClick={() => reset()}
            style={{ padding: '8px 20px', borderRadius: 8, border: '1px solid #333', background: '#1a1a1a', color: '#f5f0e8', cursor: 'pointer', fontSize: 14 }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
